import React, { Component } from 'react';
import _ from 'lodash';
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';
import './PriceRange.css';

class PriceRange extends Component {
  constructor(props) {
    super(props);
    this.prefix = 'price-range';
    this.state = {
      value: {
        min: parseInt(props.valuefrom) || 0,
        max: parseInt(props.valueto) || 10000,
      },
    };
  }
  componentDidMount() {}
  onChangeComplete(value) {}
  render() {
    return (
      <div className='price-range-container'>
        <div>
          <p style={{ textAlign: 'center' }}>
            {this.state.value.min} - {this.state.value.max}
          </p>
        </div>
        <InputRange
          step={100}
          minValue={0}
          maxValue={20000}
          value={this.state.value}
          onChange={(value) => this.setState({ value })}
        />
        <input
          type='hidden'
          name={this.props.pricefrom}
          id={this.props.pricefrom}
          value={this.state.value.min}></input>
        <input
          type='hidden'
          name={this.props.priceto}
          id={this.props.priceto}
          value={this.state.value.max}></input>
      </div>
    );
  }
}

export default PriceRange;
